import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface TaskTitleFieldProps {
  title: string
  onSave: (title: string) => void
}

/** Edición en línea del título (CLAUDE.md §6): clic para editar, Enter/blur guarda, Escape descarta. */
export function TaskTitleField({ title, onSave }: TaskTitleFieldProps) {
  const { t } = useTranslation()
  const [editing, setEditing] = useState(false)
  const [value, setValue] = useState(title)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (editing) inputRef.current?.focus()
  }, [editing])

  function startEditing(): void {
    setValue(title)
    setEditing(true)
  }

  function commit(): void {
    setEditing(false)
    const trimmed = value.trim()
    if (trimmed && trimmed !== title) onSave(trimmed)
  }

  if (editing) {
    return (
      <input
        ref={inputRef}
        value={value}
        aria-label={t('task.detail.titleFieldLabel')}
        onChange={(event) => setValue(event.target.value)}
        onBlur={commit}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            commit()
          }
          if (event.key === 'Escape') {
            setValue(title)
            setEditing(false)
          }
        }}
        className="-mx-2 w-[calc(100%+16px)] rounded-card bg-surface-hi px-2 py-1 text-title font-semibold text-text outline-none focus-visible:ring-2 focus-visible:ring-accent"
      />
    )
  }

  return (
    <button
      type="button"
      onClick={startEditing}
      className="-mx-2 w-[calc(100%+16px)] rounded-card px-2 py-1 text-left text-title font-semibold text-text hover:bg-surface-hi focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
    >
      {title}
    </button>
  )
}
